export default __webpack_public_path__ + "static/media/zelle.e60a3dba.svg";